import React from "react";
import { FaPhoneAlt, } from 'react-icons/fa';
import { MdMail, MdLocationPin } from 'react-icons/md';
import { useFormik } from "formik";
// import Maps from "../../components/Maps";
import Ouvidoria from "../../components/Ouvidoria";

import './contact.scss';

import TitleAbout from "../../components/Title";
import SEO from "../../SEO/SEO";

// fuction validate form
const validate = values => {
  const errorMsg = "Deve ter 20 caracteres ao menos";
  const errorMessage = "Sua mensagem deve quer ao menos 60 caracteres";
  const errors = {};

  if(!values.name){
    errors.name = "Required";
  }else if(values.name.lenght > 20){
    errors.name = errorMsg;
  }

  if(!values.email){
    errors.email = "Required";
  }else if(values.email.lenght > 20){
    errors.email = errorMsg;
  }

  if(!values.message){
    errors.message = "Required";
  }else if(values.message.lenght > 60){
    errors.message = errorMessage;
  }
  
  return errors;
}


export default function Contact(){
  
  // Variables Formik Forms
  const formik = useFormik({
    initialValues: {
      name: "",
      email:"",
      phone: "",
      city:"",
      message:"",
    },
    validate,
    onSubmit: values =>{
      alert(JSON.stringify(values, null, 5));
    }
  })

  return(
    <>
      <SEO title="Contato - Séculos Engenharia e Serviços LTDA" link='https://seculosengenharia.com.br/contato' />
      <TitleAbout name="Contato" link1={"Home/ "} link2={"Contato"} />

      <section id="contact" className="contato">
        <div className="container contact">
          <div className="contact-row">
            <div className="contact-box"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0">
              <FaPhoneAlt size={40} />
              <h3>Telefone</h3>
              {/* <a href="9433461014" target="_blank">(94) 3346-1014</a> <br/> */}
              <a href="9433466200" target="_blank">(94) 3346-6200</a>
            </div>

            <div className="contact-box"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0">
              <MdMail size={40} />
              <h3>E-mails</h3>
              <a href='mailto:seculos@seculosengenharia.com.br'>seculos@seculosengenharia.com.br</a> <br/>
              <a href="mailto:ouvidoria@gruposeculos.com.br">ouvidoria@seculosengeharia.com.br</a>
            </div>

            <div className="contact-box"
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0">
              <MdLocationPin size={40} />
              <h3>Endereço</h3>
                <a href='https://goo.gl/maps/n7nbaKd2LzL6Kss38' target="blank">
                    Av. Tupinambá, 498 - Parque dos Carajás, Parauapebas - PA
                </a>
            </div>
          </div>

          <div className="contact-desc">
            <h2
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0">Soluções eficientes para seus projetos</h2>
            <p
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0">
                Para solicitar nossos serviços ou saber mais sobre nossas soluções, entre em contato conosco. Teremos a maior satisfação em atendê-lo(a) e encontrar a melhor solução para sua demanda.
            </p>
          </div>
        </div>
      </section>

      <section className="maps container">
        <div className="maps-box">
          <h2
            data-aos="fade-zoom-in" 
            data-aos-duration="1000"
            data-aos-delay="300"
            data-aos-offse="0">Nosso Endereço</h2>
          <p>Av. Tupinambá, 498 - Parque dos Carajás, Parauapebas - PA</p>

          <button>
            <a href="https://maps.app.goo.gl/KAdZB3GGav9eKmhp9" target="blank">LOCALIZAÇÃO</a>
          </button>
        </div>

        <div className="maps-box">
          <div className="maps-form">
            <h2
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0">Contate-nos</h2>
            <div className="form" 
              data-aos="fade-up"
              data-aos-duration="1000"
              >
              <form onSubmit={formik.handleSubmit}
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
                <input 
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Nome"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                />
                {formik.errors.name ? <div>{formik.errors.name}</div> : null}
                <br/>

                <br/>
                <input 
                  id="email"
                  name="email"
                  type="text"
                  placeholder="E-mail"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
                {formik.errors.email ? <div>{formik.errors.email}</div> : null}
                <br/>

                <br/>
                <input 
                  id="phone"
                  name="phone"
                  type="tel"
                  placeholder="Telefone"
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                  onChange={formik.handleChange}
                  value={formik.values.phone}
                />
                <br/>

                <br/>
                <input
                  id="city"
                  name="city"
                  type="text"
                  placeholder="Cidade"
                  onChange={formik.handleChange}
                  values={formik.values.city}
                />
                <br/>

                <br/>
                <textarea
                  id="message"
                  name="message"
                  type="text"
                  placeholder="Digite sua mensagem"
                  onChange={formik.handleChange}
                  value={formik.values.message}
                >
                </textarea>
                {formik.errors.message? <div>{formik.errors.message}</div> : null}
                <br/>

                <button type="submit">Enviar</button>

                </form>
            </div>
          </div>
        </div>
      </section>

      <Ouvidoria />

    </>
  )
}